import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { TourInstallmentInputForm } from '@/features/dashboard/tourConfig/schemas/tourInstallmentsSchema.ts';
import { PaymentMethod } from '@/features/dashboard/tourConfig/types/PaymentMethod.ts';
import useGetBankAccounts from '@/features/dashboard/paymentConfig/hooks/useGetBankAccounts.ts';
import useGetTourPriceRange from '@/features/dashboard/tourConfig/hooks/useGetTourPriceRange.ts';
import { tourConfigInstallmentsRoute } from '@/features/dashboard/tourConfig/routes/tourConfigInstallmentsRoute.ts';

export default function useBankAccountSync() {
  const { tourId } = tourConfigInstallmentsRoute.useParams();
  const { getValues, setValue } = useFormContext<TourInstallmentInputForm>();
  const { data: bankAccounts } = useGetBankAccounts();
  const { data: priceRanges } = useGetTourPriceRange(tourId);

  const onPaymentMethodsChange = useCallback(() => {
    const installments = getValues('installments');

    const hasAnyTransfer = (installments ?? []).some((inst) =>
      inst.paymentMethods?.includes(PaymentMethod.TRANSFER),
    );

    if (hasAnyTransfer) {
      const current = getValues('bankAccountSelections') ?? [];
      if (current.some((s) => s.bankAccountId)) return;

      if (!priceRanges) return;

      const entries = priceRanges.map((range) => {
        const currency = range.min.currency;
        const defaultAccount = bankAccounts?.find(
          (ba) => ba.currency === currency && ba.isDefault,
        );
        return {
          currency,
          bankAccountId: defaultAccount?.id ?? '',
        };
      });

      setValue('bankAccountSelections', entries);
    } else {
      setValue('bankAccountSelections', []);
    }
  }, [getValues, setValue, bankAccounts, priceRanges]);

  return { onPaymentMethodsChange };
}
